import BaseImage from "@/app/(site)/_components/Atoms/BaseImage"
import { type ImageElementType } from "@/gc-sanity-types"
import { getAccessibleImageAlt } from "@/src/utils/a11y/getAccessibleImageAlt"
import { clsx } from "@/src/utils/clsx"

interface ImageElementProps extends ImageElementType {
    isAboveTheFold?: boolean
    sizes?: string
    overrideObjectSetting?: string
}

export const getObjectFitClass = (setting: string | undefined): string => {
    switch (setting) {
        case "cover":
            return "object-cover"
        case "contain":
            return "object-contain"
        case "fill":
            return "object-fill"
        case "fit":
            return "object-scale-down" // Note: Tailwind uses object-scale-down instead of object-fit
        default:
            return ""
    }
}

export const getObjectPositionClass = (position: string | undefined): string => {
    switch (position) {
        case "top":
            return "object-top"
        case "center":
            return "object-center"
        case "bottom":
            return "object-bottom"
        case "left":
            return "object-left"
        case "right":
            return "object-right"
        default:
            return ""
    }
}

export default function ImageElement({
    image,
    focalPoint,
    objectSetting: propObjectSetting,
    isAboveTheFold,
    sizes,
    overrideObjectSetting
}: ImageElementProps) {
    const altText = getAccessibleImageAlt(image.alt) || image.caption || ""
    const finalObjectSetting = overrideObjectSetting || propObjectSetting

    return (
        <div className="relative h-full w-full">
            <BaseImage
                src={image.asset?._ref || ""}
                alt={altText}
                asset={image.asset}
                fill
                mimeType={image.asset?.mimeType || ""}
                isAboveTheFold={isAboveTheFold}
                className={clsx(
                    getObjectFitClass(finalObjectSetting),
                    getObjectPositionClass(focalPoint)
                )}
                sizes={sizes}
            />
        </div>
    )
}
